'use client'
import {
  Col,
  CopyButton,
  Icon,
  MultiplyBadge,
  Row,
  Typography,
} from '@repo/ui/components'

import Image from 'next/image'
import { useTranslate } from '@repo/shared/hooks'
import {
  useGetLoyaltyMissions,
  useGetLoyaltyPortfolio,
  useGetReferralCodes,
} from '@repo/services'
import { globalConfig } from '@repo/shared/utils'
import { InformationDialog, ValueWithUnit } from '@repo/shared/components'

export const ReferralProgram = () => {
  const { t } = useTranslate()
  const { data: { data: { portfolio = {} } = {} } = {} } =
    useGetLoyaltyPortfolio()

  const coefficient = Math.floor((portfolio.coefficient ?? 0) * 100) / 100
  const { data } = useGetReferralCodes()
  const { data: missions } = useGetLoyaltyMissions()
  const missionKyc = missions?.data.missions?.find(
    (mission) => mission.mission?.name === 'kyc_approval',
  )
  const missionTrade = missions?.data.missions?.find(
    (mission) => mission.mission?.name === 'otc_trade',
  )

  const referralCode = data?.data?.codes?.[0]?.code

  const handleShare = (platform: string) => {
    const url = `${globalConfig.baseUrl}/ref/${referralCode}`
    const text = t('referralProgram_share_title_user', { url })

    switch (platform) {
      case 'telegram':
        window.open(
          `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
        )
        break
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text)}`)
        break
      case 'twitter':
        window.open(
          `https://x.com/intent/tweet?text=${encodeURIComponent(text)}`,
        )
        break
      case 'instagram':
        // Instagram doesn't have direct sharing URL, so we'll copy to clipboard
        navigator.share({
          title: text,
          // url: url,
        })
        break
    }
  }

  return (
    <div className='bg-base-radial-gradient  rounded-md border-4 border-base-main-20 w-full'>
      <Col className=' p-6 w-full gap-md mx-auto rounded-md'>
        <Row className='gap-2xs'>
          <Typography size='sm' weight='bold' color='text-base-main-100'>
            {t('referralProgram_title')}
          </Typography>
          <InformationDialog
            title={t('referralProgram_title')}
            iconColor='fill-base-main-100'
          >
            <div className='whitespace-pre-line mb-md'>
              {t('info_referralProgram_title')}
            </div>
            <Image
              src='/images/reward.png'
              alt='referral-program'
              width={450}
              height={450}
            />
          </InformationDialog>
        </Row>

        <Col className='gap-2xs'>
          <Row className='justify-between items-start'>
            <Typography size='sm' color='text-base-main-100' className=''>
              {t('referralProgram_registrationReward')}
            </Typography>
            <Row className=' gap-2xs w-fit justify-end'>
              <MultiplyBadge value={coefficient} size='xs' hideIcon />
              <ValueWithUnit
                value={missionKyc?.mission?.points ?? 0}
                // unit={'SQ2'}
                valueSize='md'
                unitSize='2xs'
                unitColor='text-base-main-100'
                valueColor='text-base-main-100'
                valueWeight='bold'
              />
              <Image
                src='/images/club-gem.svg'
                alt='coin'
                width={20}
                height={20}
              />
            </Row>
          </Row>

          <Row className='justify-between items-start'>
            <Typography size='sm' color='text-base-main-100' className=''>
              {t('referralProgram_tradingReward')}
            </Typography>
            <Row className=' gap-2xs w-fit justify-end'>
              <MultiplyBadge value={coefficient} size='xs' hideIcon />

              <ValueWithUnit
                value={missionTrade?.mission?.points ?? 0}
                // unit={'SQ2'}
                valueSize='md'
                unitSize='2xs'
                unitColor='text-base-main-100'
                valueColor='text-base-main-100'
                valueWeight='bold'
              />
              <Image
                src='/images/club-gem.svg'
                alt='coin'
                width={20}
                height={20}
              />
            </Row>
          </Row>
        </Col>

        <Row className='bg-base-main-100/10 backdrop-blur-sm rounded-xs p-2xs'>
          <Row className='flex items-center justify-between gap-2'>
            <CopyButton
              text={`${globalConfig.baseUrl}/ref/${referralCode}`}
              nonActiveTitle={t('common_copy')}
              activeMessageTitle={t('common_copied')}
            />
            <Typography
              size='sm'
              color='text-base-main-100'
              className='ltr px-2xs'
            >
              {globalConfig.baseUrl?.replace('https://', '')}/ref/{referralCode}
            </Typography>
          </Row>
        </Row>

        <Row className='text-center justify-between'>
          <Typography size='2xs' color='text-base-main-80'>
            {t('referralProgram_shareOn')}
          </Typography>
          <div className='flex justify-center gap-xs'>
            <button
              onClick={() => handleShare('whatsapp')}
              className='w-8 h-8 bg-base-main-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-base-main-60 transition-colors'
            >
              <Icon name='WhatsappFill' size='xs' color='fill-base-main-100' />
            </button>

            <button
              onClick={() => handleShare('telegram')}
              className='w-8 h-8 bg-base-main-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-base-main-60 transition-colors'
            >
              <Icon name='TelegramFill' size='xs' color='fill-base-main-100' />
            </button>
            <button
              onClick={() => handleShare('twitter')}
              className='w-8 h-8 bg-base-main-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-base-main-60 transition-colors'
            >
              <Icon name='X' size='xs' color='fill-base-main-100' />
            </button>
            <button
              onClick={() => handleShare('instagram')}
              className='w-8 h-8   bg-base-main-5 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-base-main-60 transition-colors'
            >
              <Icon name='ShareAndroid' size='xs' color='fill-base-main-100' />
            </button>
          </div>
        </Row>
      </Col>
    </div>
  )
}
